<!--  -->
<template>
  <div>
        <section class="contact-section">
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <div class="contact--info-area">
                        <h3>个人数据</h3>
                        <div class="single-info">
                            <h5>学习时间</h5>
                            <p>
                                <i class="icon_house_alt"></i>
                                744 New York Ave, Brooklyn, Kings,<br> New York 10224
                            </p>
                        </div>
                        <div class="single-info">
                            <h5>正确率</h5>
                            <p>
                                <i class="icon_phone"></i>
                                (+642) 245 356 432<br>
                                (+420) 336 476 328
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="contact-form">
                        <h4>个人信息</h4>
                        <p>你可以修改你的个人信息</p>
                        <el-form ref="form" :model="user" label-width="80px">
                            <el-form-item label="个人姓名">
                                <el-input v-model="user.name"></el-input>
                            </el-form-item>
                            <el-form-item label="邮箱">
                                 <el-input v-model="user.email"></el-input>
                            </el-form-item>
                            <el-form-item label="所学科目">
                               <el-tag
                                    style="margin-left: 5px;"
                                    v-for="tag in paperSubs"
                                    :key="tag"
                                    >
                                    {{tag}}
                                </el-tag>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="updateInfo()">提交修改</el-button>
                                <el-button type="success" @click="visibleChgPwd=true;">修改密码</el-button>
                            </el-form-item>
                            </el-form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <el-dialog
        title="输入新密码"
        :visible.sync="visibleChgPwd"
        width="30%"
        center>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="原密码" prop="currentPassword">
                <el-input  type="password" v-model="ruleForm.currentPassword"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="newPassword">
                <el-input type="password" v-model="ruleForm.newPassword" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
                <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="chgPassword('ruleForm')">提交</el-button>
                <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
        </el-form>
        </el-dialog>
  </div>
</template>

<script>
import {Message} from "element-ui";
export default {
  data () {
    var checkAge = (rule, value, callback) => {
        if (!value) {
            return callback(new Error('请输入原密码'));
        }else{
            callback();
        }
    };
    var validatePass = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('请输入新密码'));
        } else {
            if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
            }
            callback();
        }
    };
    var validatePass2 = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请再次输入密码'));
    } else if (value !== this.ruleForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
    } else {
        callback();
    }
    };
    return {
        user:{
           
        },
        paperSubs:[],
         visibleChgPwd:false,
        ruleForm: {
          newPassword: '',
          checkPass: '',
          currentPassword: ''
        },
        rules: {
          newPassword: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ],
          password: [
            { validator: checkAge, trigger: 'blur' }
          ]
        }
    };
  },

  components: {},

  computed: {},

  mounted(){
      this.$axios.get("/api/auth/me").then(res => {
          this.user = res.data.data;
            let arrhasCourse = [];
            for (var i = 0; i <res.data.data.needexaminee.length; i++)
            {
                arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
            }
            this.paperSubs = arrhasCourse;
        })
  },

  methods: {
      updateInfo(){
          this.$axios.put("/api/auth/updatedetails", this.user).then(res => {
                if(res.data){
                    Message.success("更新成功");
                }
          })
      },
      chgPassword(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            //alert('submit!');
            this.$axios.put("/api/auth/updatePassword", this.ruleForm).then(res => {
                if(res.data){
                    Message.success("更新成功");
                }
                this.visibleChgPwd = false;
            })
          } else {
            //console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
  }
}

</script>
<style scoped>
</style>